export default __webpack_public_path__ + "static/media/warningClose.6cd29688.svg";